import { EXTERNAL_LINKS } from '../common/links';

const exLinkTo = (e) => {
    const link_url = e.target.value;
    console.log(link_url);
    console.log(e);
    window.open(EXTERNAL_LINKS[link_url], '_blank', 'noopener');
    return;
}
export default exLinkTo;